var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E23131",
  fillRule: "evenodd",
  d: "M9 .917a8.084 8.084 0 1 1 0 16.167A8.084 8.084 0 0 1 9 .917m.006 10.944a.75.75 0 0 0-.75.75v.006a.75.75 0 0 0 1.5 0v-.006a.75.75 0 0 0-.75-.75M9 4.25a.584.584 0 0 0-.583.583v5a.584.584 0 0 0 1.167 0v-5A.584.584 0 0 0 9 4.25",
  clipRule: "evenodd"
})));
export default SvgWarningCircle;